import { Action } from '../redux';

export enum AppActionType {
    SET_SHOW_PROGRESS = 'App > Set Show Progress'
}

export interface ISetShowProgressAction extends Action {
    show: boolean;
    text?: string;
    redirect?: string;
}

export interface IAppActions {
    setShowProgress(show: boolean, redirect?: string): ISetShowProgressAction;
}

export class AppActions implements IAppActions {
    readonly setShowProgress = this._setShowProgress.bind(this);

    private _setShowProgress(show: boolean, redirect?: string): ISetShowProgressAction {
        return {
            type: AppActionType.SET_SHOW_PROGRESS,
            show,
            redirect
        };
    }
}
